import React, { Ref } from "react";
import Select from "react-select";

import FileSelect from "../../components/FileSelect";

type MultipleFileSelectorProps = {
  filePickerRef: Ref<HTMLInputElement>;
  files: Array<File>;
  setFiles: (files: Array<File>) => void;
  placeholder?: string;
  isDisabled?: boolean;
  required?: boolean;
};

const DisabledComponent = () => <></>;

const MultipleFileSelector: React.FC<MultipleFileSelectorProps> = ({
  filePickerRef,
  files,
  setFiles,
  placeholder,
  isDisabled = false,
  required = false
}) => {
  const options = files.map(file => ({
    label: file.name,
    value: file.name
  }));
  return (
    <>
      <FileSelect
        id="file-analysis-file-picker"
        ref={filePickerRef}
        onChange={e => setFiles(Array.from(e.target.files || []))}
        isMultiple
      />
      <Select
        classNames={{
          valueContainer: () => "file-selector-value-container"
        }}
        isClearable
        isMulti
        isSearchable={false}
        isDisabled={isDisabled}
        placeholder={placeholder}
        options={options}
        value={options}
        onChange={selection => {
          const fileNames = selection.map(s => s.value);
          setFiles(files.filter(file => fileNames.includes(file.name)));
        }}
        components={{
          Menu: DisabledComponent,
          DropdownIndicator: DisabledComponent,
          IndicatorSeparator: DisabledComponent
        }}
        required={required}
      />
    </>
  );
};

export default MultipleFileSelector;
